import ICTunai from 'assets/icons/currency-dollar.svg'
import ICDefaultPhoto from 'assets/icons/default-ava-profile-user.svg'
import ICPhone from 'assets/icons/ic-mobile.png'
import ICUangBelanja from 'assets/icons/uang-belanja-wallet.png'
import ICTalangin from 'assets/icons/uang-usaha.png'
import axios from 'axios'
import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import SvgIcon from 'components/Icon/SvgIcon'
import ProfilePic from 'components/PMBProfilePic'
import PMBImageWithToken from 'components/PMBImageWithToken'
import PMBModalImagePreview from 'components/PMBModalImagePreview'
import PMBTooltip from 'components/PMBTooltip'
import { PMBFormatDate, authHeaderFor } from 'helpers'
import { useState } from 'react'
import {
  AlertCircle,
  Edit2,
  ExternalLink,
  FileText,
  Plus,
  User,
} from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, CardBody, Col, Row } from 'reactstrap'
import {
  URL_DETAIL_PIUTANG,
  URL_DETAIL_TAGIHAN_TALANGIN,
  URL_DETAIL_UTANG,
  URL_PROJECTS_MENU,
} from 'utils/pathUrl'
import { ResponsiveActionButton } from 'components/Buttons'
import { toggleModalNoTrx, toggleModalEdithProject } from '../../dashboardSlice'
import { useAbilityAccess } from 'hooks/useAbilityAccess'
import {
  BUSINESS_TRANSACTION_PURCHASE,
  BUSINESS_TRANSACTION_SELL,
  MANAGE,
} from 'utils/subjectActions'

const TransactionInformation = ({
  transaction,
  transactionNoteData,
  isBuyer,
  isCreator,
  ownerUserId,
  sellerUserId,
  buyerUserId,
  toggleNoteModal,
  setIsNoteModalOpenEdit,
}) => {
  const { ownerData, profile } = useSelector((s) => s.dashboard)
  const { token } = useSelector((s) => s.auth)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const [urlImage, setUrlImage] = useState([])
  const [isOpenModalPreview, setIsOpenModalPreview] = useState(false)
  const searchParams = new URLSearchParams(location.search)
  const transactionType = searchParams.get('type')

  const isInitiator =
    transaction?.orderDetail?.type === 'BUY'
      ? transaction?.buyerDetail?.userId == ownerData?.userId
      : transaction?.sellerDetail?.userId == ownerData?.userId

  const canSell = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_TRANSACTION_SELL,
  })

  const canBuy = useAbilityAccess({
    action: MANAGE,
    subject: BUSINESS_TRANSACTION_PURCHASE,
  })

  const detailProjects = (() => {
    if (Array.isArray(transaction?.projects) && transaction.projects.length > 0) {
      const seen = new Set()
      const list = []
      transaction.projects.forEach((p) => {
        const id = p?.id ?? p?.projectId
        const label = p?.label ?? p?.projectLabel ?? p?.projectName ?? p?.title
        const key = id !== undefined && id !== null ? String(id) : label
        if (key && !seen.has(key)) {
          seen.add(key)
          list.push({ id, label: label || `Project #${id}` })
        }
      })
      if (list.length > 0) return list
    }

    const legacyId = transaction?.projectId
    const legacyLabel =
      transaction?.projectTitle ||
      transaction?.projectName ||
      (legacyId ? `Project #${legacyId}` : null)

    if (legacyId || legacyLabel) {
      return [{ id: legacyId, label: legacyLabel }]
    }
    return []
  })()

  const fetchFileBlob = async (url) => {
    const response = await axios.get(url, {
      headers: authHeaderFor(url, token),
      responseType: 'blob',
    })
    return response.data
  }

  const onShowImagePreview = async (item) => {
    try {
      const blob = await fetchFileBlob(item)
      const url = URL.createObjectURL(blob)
      setUrlImage([url])
      setIsOpenModalPreview(true)
    } catch (error) {
      console.error('Terjadi kesalahan saat memuat file dengan token', error)
    }
  }

  const onOpenDocument = async (item) => {
    const tab = window.open('', '_blank')
    if (!tab) return
    try {
      tab.opener = null
      const blob = await fetchFileBlob(item)
      const pdf = new Blob([blob], { type: 'application/pdf' })
      const url = URL.createObjectURL(pdf)
      tab.location.href = url
    } catch (error) {
      tab.close()
      console.error('Terjadi kesalahan saat memuat file dengan token', error)
    }
  }

  const onDownloadDocument = async (item, fileName) => {
    try {
      const blob = await fetchFileBlob(item)
      const cleanUrl = (item || '').split('?')[0]
      const ext = cleanUrl.substring(cleanUrl.lastIndexOf('.') + 1) || 'file'
      const name = fileName
        ? `${fileName}.${ext}`
        : cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1) || `dokumen.${ext}`
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = name
      a.click()
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Terjadi kesalahan saat mengunduh file', error)
    }
  }

  const getFileUrl = (file) =>
    (typeof file === 'string' ? file : file?.linkphoto || file?.url || file?.fileUrl || '')

  const isPdfFile = (file) => {
    const url = getFileUrl(file).toLowerCase().split('?')[0]
    return (
      url.endsWith('.pdf') ||
      file?.mimeType?.toLowerCase() === 'application/pdf' ||
      file?.type?.toLowerCase() === 'application/pdf'
    )
  }

  const isOfficeFile = (file) => {
    const url = getFileUrl(file).toLowerCase().split('?')[0]
    return ['.doc', '.docx', '.xls', '.xlsx', '.csv'].some((ext) =>
      url.endsWith(ext),
    )
  }

  const renderEscrowFile = (file, label, index) => {
    const fileUrl = getFileUrl(file)
    const key = `${fileUrl}-${index}`

    if (isPdfFile(file)) {
      return (
        <button
          key={key}
          type="button"
          className="btn btn-link p-0 d-flex flex-column align-items-center text-primary text-decoration-none"
          onClick={() => onOpenDocument(fileUrl)}
        >
          <FileText size={36} />
          <span style={{ fontSize: '0.8rem', marginTop: '4px' }}>Buka PDF</span>
        </button>
      )
    }

    if (isOfficeFile(file)) {
      return (
        <button
          key={key}
          type="button"
          className="btn btn-link p-0 d-flex flex-column align-items-center text-primary text-decoration-none"
          onClick={() => onDownloadDocument(fileUrl, label)}
        >
          <FileText size={36} />
          <span style={{ fontSize: '0.8rem', marginTop: '4px' }}>Unduh File</span>
        </button>
      )
    }

    return (
      <PMBImageWithToken
        key={key}
        source={fileUrl}
        token={token}
        alt={label}
        className="rounded"
        style={{ width: '100px', height: 'auto', objectFit: 'cover', cursor: 'pointer' }}
        onClick={() => onShowImagePreview(fileUrl)}
      />
    )
  }

  return (
    <>
      <Card className="shadow-sm border-0 mb-3">
        <CardBody>
          <h6 className="fw-semibold mb-3">Informasi transaksi</h6>

          {/* {transaction?.orderDetail?.poNumber && ( */}
          <Row className="mb-3">
            <Col xs="6" className="fw-light text-sm">
              No. transaksi
              <AlertCircle
                className="ms-1 text-secondary"
                size={15}
                id={`tooltip-${transaction?.id}`}
              />
              <PMBTooltip
                placement="right"
                target={`tooltip-${transaction?.id}`}
                text={'Nomor transaksi sistem'}
              />
            </Col>
            <Col xs="6" className="fw-semibold text-sm">
              {transaction?.orderDetail?.poNumber ||
                transaction?.orderDetail?.transaction_number ||
                transaction?.trxNumber ||
                transaction?.noTrx ||
                '-'}
            </Col>
          </Row>
          {/* // )} */}

          {(transaction?.trxDate || transaction?.createdAt) && (
            <Row className="mb-3">
              <Col xs="6" className="fw-light text-sm">
                Tanggal transaksi
              </Col>
              <Col xs="6" className="fw-semibold text-sm">
                {PMBFormatDate(transaction?.trxDate || transaction?.createdAt) ?? '-'}
              </Col>
            </Row>
          )}

          {(ownerUserId === buyerUserId || ownerUserId === sellerUserId) &&
            isCreator && (
              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Dibuat oleh
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  <div className="d-flex gap-2 align-items-center">
                    <ProfilePic
                      imgSrc={transaction?.requesterAvatar}
                      altText={
                        transaction?.requesterName ||
                        (transaction?.orderDetail?.type === 'BUY'
                          ? transaction?.buyerDetail?.name || transaction?.buyerDetail?.fullName
                          : transaction?.sellerDetail?.name || transaction?.sellerDetail?.fullName)
                      }
                      name={
                        transaction?.requesterName ||
                        (transaction?.orderDetail?.type === 'BUY'
                          ? transaction?.buyerDetail?.name || transaction?.buyerDetail?.fullName
                          : transaction?.sellerDetail?.name || transaction?.sellerDetail?.fullName)
                      }
                      avatarSeed={
                        transaction?.orderDetail?.type === 'BUY'
                          ? transaction?.buyerDetail?.userId
                          : transaction?.sellerDetail?.userId
                      }
                      width={20}
                      height={20}
                    />
                    <span
                      style={{
                        wordBreak: 'break-word',
                      }}
                    >
                      {transaction?.requesterName
                        ? transaction?.requesterName
                        : isBuyer
                          ? transaction?.buyerDetail?.name || transaction?.buyerDetail?.fullName
                          : transaction?.sellerDetail?.name || transaction?.sellerDetail?.fullName}
                    </span>

                    {!transaction?.orderDetail?.source && (
                      <img src={ICPhone} alt="Mobile" width={24} height={24} />
                    )}
                  </div>
                </Col>
              </Row>
            )}

          {(transaction?.picBuyerDetail ||
            transaction?.buyerDetail?.partnership?.name) && (
              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  PIC Pembeli
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  <div className="d-flex flex-column align-items-start">
                    <span
                      style={{
                        wordBreak: 'break-word',
                      }}
                    >
                      {transaction?.picBuyerDetail?.name ?? '-'}
                    </span>
                    {transaction?.buyerDetail?.partnership?.name && (
                      <div
                        className="badge rounded-pill text-primary bg-gray-100 font-semibold px-2 mt-1"
                        style={{
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          textAlign: 'center',
                          maxWidth: '100%',
                        }}
                      >
                        {transaction?.buyerDetail?.partnership?.name}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            )}

          {(transaction?.picSellerDetail ||
            transaction?.sellerDetail?.partnership?.name) && (
              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  PIC Penjual
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  <div className="d-flex flex-column align-items-start">
                    <span
                      style={{
                        wordBreak: 'break-word',
                      }}
                    >
                      {transaction?.picSellerDetail?.name ?? '-'}
                    </span>
                    {transaction?.sellerDetail?.partnership?.name && (
                      <div
                        className="badge rounded-pill text-primary bg-gray-100 font-semibold px-2 mt-1"
                        style={{
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          textAlign: 'center',
                          maxWidth: '100%',
                        }}
                      >
                        {transaction?.sellerDetail?.partnership?.name}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            )}

          <Row className="mb-3">
            <Col xs="6" className="fw-light text-sm">
              Status
            </Col>
            <Col xs="6" className="text-sm">
              {(() => {
                const statusMap = {
                  selesai: 'bg-success-50 text-success',
                  'menunggu proses penjual': 'bg-warning-50 text-warning-700',
                  'dalam penyesuaian': 'bg-warning-50 text-warning-700',
                  'menunggu approval admin': 'bg-warning-50 text-warning-700',
                  diproses: 'bg-primary-50 text-primary',
                  dibatalkan: 'bg-danger-50 text-danger-700',
                  expired: 'bg-danger-50 text-danger-700',
                  'menunggu pembayaran pembeli':
                    'bg-warning-50 text-warning-700',
                  'menunggu konfirmasi pembayaran':
                    'bg-warning-50 text-warning-700',
                }

                const status = transaction?.status?.toLowerCase()
                const badgeClass =
                  statusMap[status] || 'bg-secondary-50 text-secondary'

                return (
                  <div
                    className={`badge rounded-pill ${badgeClass} px-2`}
                    style={{
                      wordBreak: 'break-word',
                      whiteSpace: 'normal',
                    }}
                    data-testid="detail-transaction-header-status"
                  >
                    {transaction?.status?.toLowerCase() === 'diproses'
                      ? 'Diproses oleh Penjual'
                      : transaction?.status}
                  </div>
                )
              })()}
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs="6" className="fw-light text-sm">
              Metode pembayaran
            </Col>
            <Col xs="6" className="text-sm d-flex flex-column justify-content-start">
              {(() => {
                const method = transaction?.paymentMethod
                const mLower = String(method || '').trim().toLowerCase()

                if (
                  !method ||
                  !mLower ||
                  mLower === '-' ||
                  mLower === 'tidak diketahui' ||
                  mLower === 'belum ditentukan' ||
                  transaction?.status === 'Menunggu Pembayaran Pembeli'
                ) {
                  return <span>-</span>
                }

                if (mLower.includes('cod')) {
                  return (
                    <div
                      className={`badge rounded-pill bg-purple-50 text-purple-700 px-2 py-1 flex-centered gap-1`}
                      style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
                    >
                      <SvgIcon name="old-icons-hand-holding-usd" size={16} color="white" withBackground={true} backgroundColor="#7F56D9" />
                      <span>{method}</span>
                    </div>
                  )
                }
                if (mLower.includes('kredit')) {
                  return (
                    <div
                      className={`badge rounded-pill bg-primary-50 px-2 flex-centered gap-1`}
                      style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
                    >
                      <SvgIcon name="database" size={16} color="white" withBackground={true} backgroundColor="#039855" />
                      <span className="text-primary">{method}</span>
                    </div>
                  )
                }
                if (mLower.includes('tunai') && !mLower.includes('non')) {
                  return (
                    <div
                      className="badge rounded-pill bg-gray-100 text-gray-700 px-2 py-1 flex-centered gap-1"
                      style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
                    >
                      <img width={20} height={20} src={ICTunai} alt={method} />
                      {method}
                    </div>
                  )
                }
                if (mLower.includes('talangan') || mLower.includes('talangin')) {
                  return (
                    <div
                      className={`badge rounded-pill bg-warning-50 px-2 py-1 flex-centered gap-1`}
                      style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
                    >
                      <img width={16} height={16} src={ICTalangin} alt={method} />
                      <span className={`text-dark fw-bold`}>{method}</span>
                    </div>
                  )
                }
                if (mLower.includes('agen') || mLower.includes('agent')) {
                  return (
                    <div
                      className="badge rounded-pill text-primary-v2 bg-primary-50 px-2 py-1 flex-centered gap-1"
                      style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
                    >
                      <User size={14} /> {method}
                    </div>
                  )
                }
                if (mLower.includes('uang belanja') || mLower.includes('non tunai')) {
                  return (
                    <div
                      className={`badge rounded-pill bg-primary-50 px-2 flex-centered gap-1`}
                      style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
                    >
                      <img width={16} height={16} src={ICUangBelanja} alt={method} />
                      <span className="text-primary">{method}</span>
                    </div>
                  )
                }
                return (
                  <div
                    className={`badge rounded-pill bg-primary-50 px-2 flex-centered gap-1`}
                    style={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '100%' }}
                  >
                    <span className="text-primary">{method}</span>
                  </div>
                )
              })()}

              {transaction?.paymentBySeller?.isPaidBySeller && (
                <span className="text-muted fst-italic mt-1" style={{ fontSize: '12px' }}>
                  Dibayar dengan Kredit Penjual untuk pembeli
                </span>
              )}
            </Col>
          </Row>

          <Row className="mb-3 text-sm">
            <Col xs="6" className="fw-light">
              Project
            </Col>
            <Col
              xs="6"
              className="fw-semibold text-sm"
              style={{
                wordBreak: 'break-word',
              }}
            >
              {detailProjects.length === 0 ? (
                <p className="mb-0">-</p>
              ) : (
                <div className="d-flex flex-column gap-2">
                  {detailProjects.map((proj, idx) => (
                    <div
                      key={proj.id ?? idx}
                      className="d-flex align-items-center flex-wrap gap-1"
                    >
                      <span>{proj.label}</span>
                      {proj.id && (
                        <>
                          <ExternalLink
                            className="pointer text-primary ms-1"
                            id={`tooltip-project-link-${proj.id}`}
                            size={16}
                            onClick={() =>
                              window.open(
                                `${URL_PROJECTS_MENU}/${proj.id}?tab=summary${transaction?.projectRole?.toLowerCase() !== 'owner' ? '&shared=true' : ''}`,
                                '_blank',
                              )
                            }
                          />
                          <PMBTooltip
                            placement="top"
                            target={`tooltip-project-link-${proj.id}`}
                            text={'Lihat detail project'}
                          />
                        </>
                      )}
                    </div>
                  ))}
                  {!Array.isArray(transaction?.projects) &&
                    transaction?.projectName &&
                    transaction?.projectTitle &&
                    transaction.projectName !== transaction.projectTitle && (
                      <p className="text-muted mb-0">{transaction.projectName}</p>
                    )}
                </div>
              )}

              {![
                'RELEASED_BY_BUYER',
                'RETURNED_BY_SELLER',
                'RELEASED_BY_SELLER',
                'RETURNED_BY_ADMIN',
                'RELEASED_BY_ADMIN',
                'PENDING_BY_ADMIN',
              ].includes(transaction?.escrowpayment?.status) &&
                transaction?.status?.toLowerCase() !== 'expired' &&
                isInitiator &&
                (canSell || canBuy) && (
                  <div className="mt-2">
                    <ResponsiveActionButton
                      iconName="pencil"
                      label="Ubah project"
                      onClick={() => {
                        dispatch(toggleModalEdithProject())
                      }}
                    />
                  </div>
                )}
            </Col>
          </Row>

          {/* {transaction?.orderDetail?.transaction_number && ( */}
          <Row className="mb-3">
            <Col xs="6" className="fw-light text-sm">
              No. transaksi (custom)
              <AlertCircle
                className="ms-1 text-secondary"
                size={15}
                id={`tooltip-custom-${transaction?.id}`}
              />
              <PMBTooltip
                placement="right"
                target={`tooltip-custom-${transaction?.id}`}
                text={'Nomor transaksi pengguna'}
              />
            </Col>
            <Col
              xs="6"
              className="fw-semibold text-sm"
              style={{
                wordBreak: 'break-word',
              }}
            >
              {transaction?.orderDetail?.transaction_number
                ? transaction?.orderDetail?.transaction_number
                : '-'}{' '}
              {![
                'RELEASED_BY_BUYER',
                'RETURNED_BY_SELLER',
                'RELEASED_BY_SELLER',
                'RETURNED_BY_ADMIN',
                'RELEASED_BY_ADMIN',
                'PENDING_BY_ADMIN',
              ].includes(transaction?.escrowpayment?.status) &&
                transaction?.status?.toLowerCase() !== 'expired' &&
                isInitiator &&
                (canSell || canBuy) && (
                  <ResponsiveActionButton
                    iconName="pencil"
                    label="Ubah nomor transaksi"
                    onClick={() => {
                      dispatch(toggleModalNoTrx())
                    }}
                  />
                )}
            </Col>
          </Row>
          {/* )} */}

          <Row className="mb-3 text-sm">
            <Col xs="6" className="fw-light">
              Catatan ke penjual
            </Col>
            <Col
              xs="6"
              className="fw-semibold text-sm"
              style={{
                wordBreak: 'break-word',
              }}
            >
              {transaction?.orderDetail?.notes ??
                transaction?.orderDetail?.note ??
                '-'}
            </Col>
          </Row>

          <Row className="mb-3 text-sm">
            <Col xs="6" className="fw-light">
              Catatan transaksi{' '}
              {!transactionNoteData?.disabled &&
                transaction?.status?.toLowerCase() !== 'expired' &&
                (transactionNoteData?.buyerNote !== null ||
                  transactionNoteData?.sellerNote !== null) && (
                  <Edit2
                    size={12}
                    cursor="pointer"
                    onClick={() => {
                      toggleNoteModal()
                      setIsNoteModalOpenEdit(true)
                    }}
                  />
                )}
            </Col>
            <Col
              xs="6"
              className="fw-semibold text-sm"
              style={{
                wordBreak: 'break-word',
              }}
            >
              {!transactionNoteData?.buyerNoteHide
                ? (transactionNoteData?.buyerNote ?? '-')
                : (transactionNoteData?.sellerNote ?? '-')}
            </Col>
          </Row>

          {transaction?.escrowpayment?.goodsReceiptNote && (
            <Row className="mb-3 text-sm">
              <Col xs="6" className="fw-light">
                Catatan penerimaan barang
              </Col>
              <Col xs="6" className="fw-semibold text-sm" style={{ wordBreak: 'break-word' }}>
                {transaction.escrowpayment.goodsReceiptNote}
              </Col>
            </Row>
          )}

          {(() => {
            const normalizeFiles = (raw) => {
              if (!raw) return []
              if (Array.isArray(raw)) {
                return raw
                  .map((item) => {
                    if (!item) return null
                    if (typeof item === 'string') {
                      const url = item.trim()
                      if (url && url !== 'null' && url !== 'undefined') {
                        return { linkphoto: url }
                      }
                      return null
                    }
                    if (typeof item === 'object') {
                      const url = item?.linkphoto || item?.url || item?.fileUrl
                      if (url && url !== 'null' && url !== 'undefined') {
                        return { ...item, linkphoto: url }
                      }
                    }
                    return null
                  })
                  .filter(Boolean)
              }
              if (typeof raw === 'string') {
                const url = raw.trim()
                if (url && url !== 'null' && url !== 'undefined') {
                  return [{ linkphoto: url }]
                }
              }
              if (typeof raw === 'object') {
                const url = raw?.linkphoto || raw?.url || raw?.fileUrl
                if (url && url !== 'null' && url !== 'undefined') {
                  return [{ ...raw, linkphoto: url }]
                }
              }
              return []
            }

            const collectUniqueFiles = (...sources) => {
              const seen = new Set()
              const result = []
              sources.forEach((source) => {
                normalizeFiles(source).forEach((file) => {
                  const url = file?.linkphoto
                  if (url && !seen.has(url)) {
                    seen.add(url)
                    result.push(file)
                  }
                })
              })
              return result
            }

            const paymentProofFiles = collectUniqueFiles(
              transaction?.orderDetail?.proofOfPayment,
              transaction?.proofOfPayment,
              transaction?.escrowpayment?.proofOfPayment,
              (transaction?.escrowpayment?.files || []).filter(
                (f) => f?.purpose === 'PROOFOFPAYMENT',
              ),
            )

            const goodsReceiptFiles = collectUniqueFiles(
              transaction?.orderDetail?.escrowFiles,
              transaction?.escrowFiles,
              transaction?.escrowpayment?.escrowFiles,
              (transaction?.escrowpayment?.files || []).filter(
                (f) => f?.purpose === 'GOODSRECEIPT',
              ),
            )

            const sellerConfirmFiles = collectUniqueFiles(
              transaction?.orderDetail?.sellerConfirm,
              (transaction?.escrowpayment?.files || []).filter(
                (f) => f?.purpose === 'SELLERCONFIRM',
              ),
            )

            const otherDocumentFiles = collectUniqueFiles(
              transaction?.orderDetail?.files,
              transaction?.files,
            )

            const sections = [
              {
                key: 'proofOfPayment',
                label: 'Bukti pembayaran',
                files: paymentProofFiles,
              },
              {
                key: 'goodsReceipt',
                label: 'Bukti barang diterima',
                files: goodsReceiptFiles,
              },
              {
                key: 'sellerConfirm',
                label: 'Bukti konfirmasi penjual',
                files: sellerConfirmFiles,
              },
              {
                key: 'otherDocuments',
                label: 'Dokumen lainnya',
                files: otherDocumentFiles,
              },
            ]

            return sections.map(({ key, label, files }) => {
              if (!files.length) return null

              return (
                <Row className="mb-3 text-sm" key={key}>
                  <Col xs="12" sm="6" className="fw-light">
                    {label}
                  </Col>
                  <Col
                    xs="12"
                    sm="6"
                    className="d-flex flex-wrap gap-2 mt-2 mt-sm-0"
                  >
                    {files.map((file, index) =>
                      renderEscrowFile(file, label, index),
                    )}
                  </Col>
                </Row>
              )
            })
          })()}

          {transaction?.escrowpayment?.payableId && (
            <CustomButton
              outline
              color="primary"
              style={{ width: '100%' }}
              onClick={() => {
                if (isBuyer) {
                  navigate(
                    `${URL_DETAIL_UTANG}?id=${transaction?.escrowpayment?.payableId}`,
                    {
                      state: {
                        row: transaction,
                      },
                    },
                  )
                } else {
                  navigate(
                    `${URL_DETAIL_PIUTANG}?id=${transaction?.escrowpayment?.payableId}`,
                    {
                      state: {
                        row: transaction,
                      },
                    },
                  )
                }
              }}
            >
              {`Lihat Detail ${isBuyer ? 'Utang' : 'Piutang'}`}
            </CustomButton>
          )}

          {transaction?.escrowpayment?.userpinjamanId &&
            transaction?.status?.toLowerCase() === 'selesai' &&
            isBuyer && (
              <CustomButton
                outline
                color="primary"
                style={{ width: '100%' }}
                onClick={() => {
                  navigate(URL_DETAIL_TAGIHAN_TALANGIN, {
                    state: {
                      row: transaction,
                    },
                  })
                }}
              >
                Lihat Detail Talangin
              </CustomButton>
            )}

          {!transactionNoteData?.disabled &&
            transactionNoteData?.buyerNote === null &&
            transactionNoteData?.sellerNote === null && (
              <CustomButton
                outline
                color="primary"
                className="w-100 mt-3"
                onClick={toggleNoteModal}
              >
                <Plus size={16} className="me-2" /> Tambah Catatan Transaksi
              </CustomButton>
            )}
        </CardBody>
      </Card>

      {urlImage?.length > 0 && (
        <PMBModalImagePreview
          isOpen={isOpenModalPreview}
          toggle={() => {
            setIsOpenModalPreview(false)
            setUrlImage([])
          }}
          images={urlImage}
          isDownload
        />
      )}
    </>
  )
}

export default TransactionInformation
